export function processPaymentC2B(lang){
    const laravel=`
    $url = 'https://sandbox.sasapay.app/api/v1/payments/process-payment/';
    $data = [
      'MerchantCode' => '{{REPLACE_HERE}}',
      'CheckoutRequestID' => '{{REPLACE_HERE}}',
      'VerificationCode' => '{{REPLACE_HERE}}',
    ];
    
    $ch = curl_init($url);
    curl_setopt($ch, CURLOPT_POST, 1);
    curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    echo $response;
    `;
    const python=`
        
merchant_code = "your_merchant_code"
url = 'https://sandbox.sasapay.app/api/v1/payments/register-ipn-url/'
payload = {
    "MerchantCode": 'your_merchant_code',
    "ConfirmationUrl": "yourdomain",
}
headers = {
        'Authorization': f'Bearer "your_access_token" ' 
        }
try:
    res = requests.post(url, headers=headers,data=payload)
    response = json.loads(res.text)
    
    print(response)
except Exception as error:
    print(str(error))
    `
    const java=`Coming Soon!`

    if (lang==='php') {
        return laravel
    } else if (lang==='python') {
        return python
    } else {
        return java
    }
}
export function getC2BProcessRequestResponse(){
    return `
      {
       "status": true,
       "detail": "Transaction is being processed"
      }
    `
}

export function getCallbackIPN(){
    return `
    {
      "MerchantRequestID": "25472****77",
      "CheckoutRequestID": "3a412fbd-73d2-49a3-9091-b65e51a5e9b5",
      "ResultCode": 0,
      "ResultDesc": "Transaction processed successfully.",
      "TransAmount": "2.00",
      "BillRefNumber": "25472****77",
      "TransactionDate": "20220309081002",
      "CustomerMobile": "254715****344"
    }

    `
}
export function queryMerchantAccountBalanceRequest(lang){
    const php=`
    <?php
        $ch = curl_init('https://sandbox.sasapay.app/api/v1/payments/check-balance/?MerchantCode=40****9');
        curl_setopt($ch, CURLOPT_HTTPHEADER, [
        'Authorization: Bearer ' . base64_encode('YOUR_APP_CLIENT_ID:YOUR_APP_CLIENT_SECRET')
        ]);
        curl_setopt($ch, CURLOPT_SSL_VERIFYPEER, false);
        $response = curl_exec($ch);
        echo json_decode($response);
    `;
    if (lang==='php') {
        return php
    } else{
        return `Ops! something went wrong with our ${lang} snippets. Try again later`
    }
}
export function queryMerchantAccountBalance(){
    return `
   {
      "statusCode": "0",
      "message": "Account Balances",
      "data": {
        "CurrencyCode": "KES",
        "OrgAccountBalance": 1000.0,
        "Accounts": [
          {
            "account_label": "Bulk Payment",
            "account_balance": 0.0
          },
          {
            "account_label": "Utility Account",
            "account_balance": 0.0
          },
          {
            "account_label": "Working Account",
            "account_balance": 1000.0
          }
        ]
      }
   }

    `
}
//
export function queryStatusRequest(lang){
    const php=`
    $url = 'https://sandbox.sasapay.app/api/v1/transactions/status/';
    $data = [
      'MerchantCode' => '{{REPLACE_HERE}}',
      'CheckoutRequestId' => '{{REPLACE_HERE}}',
    ];
    
    $ch = curl_init($url);
    curl_setopt($ch, CURLOPT_POST, 1);
    curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    echo $response;
    `;
    if (lang==='php') {
        return php
    } else{
        return `Ops! something went wrong with our ${lang} snippets. Try again later`
    }
}
export function queryStatusResponse(){
    return`
   {
        "status": true,
        "message": "Transaction Details",
        "data": {
            "TransactionType": "C2B",
            "TransactionDate": "2022-05-09T10:50:48.359022Z",
            "CheckoutId": "6e1e251f-afb0-****-a097-f1ae0e0b2ce6",
            "TransactionAmount": 1.0,
            "Paid": false,
            "AmountPaid": 0.0,
            "PaidDate": "",
            "SourceChannel": "SasaPay",
            "DestinationChannel": "SasaPay"
        }
    }
    `;
}
export function ipnRequest(){
    const python=`
        import requests, json

merchant_code = "your_merchant_code"
url = 'https://sandbox.sasapay.app/api/v1/payments/register-ipn-url/'
payload = {
    "MerchantCode": 'your_merchant_code',
    "ConfirmationUrl": "yourdomain",
}
headers = {
        'Authorization': f'Bearer "your_access_token" ' 
        }
try:
    res = requests.post(url, headers=headers,data=payload)
    response = json.loads(res.text)
    
    print(response)
except Exception as error:
    print(str(error))
    `
    return python
}
export function IPNResponse() {
    return `
    {
      "MerchantCode": "6****8",
      "BusinessShortCode": "6****8",
      "InvoiceNumber": "INV-278-RID-6754",
      "PaymentMethod": "SasaPay",
      "TransID": "CDVISAIHD",
      "ThirdPartyTransID": "7***2",
      "FullName": "John kym Doe",
      "FirstName": "John",
      "MiddleName": "kym",
      "LastName": "Doe",
      "TransactionType": "C2B",
      "MSISDN": "2547*****5",
      "OrgAccountBalance": "10.00",
      "TransAmount": "10.00",
      "TransTime": "03/03/22 12:16 PM",
      "BillRefNumber": "bfhte-2hgyt-7hgk-8jgur2-jgyt78"
    }


    `
}
//verify transaction

export function verifyTransactionRequest(lang){
    const php=`
    $url = 'https://sandbox.sasapay.app/api/v1/transactions/verify/';
    $data = [
      'MerchantCode' => '{{REPLACE_HERE}}',
      'TransactionCode' => '{{REPLACE_HERE}}',
    ];
    
    $ch = curl_init($url);
    curl_setopt($ch, CURLOPT_POST, 1);
    curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    echo $response;
    `;
    //
    const java=`
        public static JSONObject verifyTransaction(String bearerToken) throws Exception {


    String url = "Endpoint";


    Map<String, Object> body = Map.of(
            "MerchantCode", "merchant_code",
            "TransactionCode", "transaction_code");


    URL obj = new URL(url);
    HttpURLConnection con = (HttpURLConnection) obj.openConnection();

    // Set request method
    con.setRequestMethod("POST");

    // Add bearer token to authorization header
    con.setRequestProperty("Authorization", "Bearer " + bearerToken);

    // Set request content type
    con.setRequestProperty("Content-Type", "application/json");

    // Set request body
    JSONObject jsonObject = new JSONObject(body);
    String requestBody = jsonObject.toString();

    // Send post request
    con.setDoOutput(true);
    DataOutputStream out = new DataOutputStream(con.getOutputStream());
    out.writeBytes(requestBody);
    out.flush();
    out.close();

    int responseCode = con.getResponseCode();
    if (responseCode != 200) {
        throw new Exception("Response code: " + responseCode);
    }

    // Get response
    BufferedReader in = new BufferedReader(new InputStreamReader(con.getInputStream()));
    String inputLine;
    StringBuilder response = new StringBuilder();
    while ((inputLine = in.readLine()) != null) {
        response.append(inputLine);
    }
    in.close();

    // Return response as JSONObject
    return new JSONObject(response.toString());
}
    `
    if (lang==='php') {
        return php
    } else if (lang==='java') {
        return java;
    }
    else{
        return `Ops! something went wrong with our ${lang} snippets. Try again later`
    }
}
export function verifyTransactionResponse(){
    const java=`
        {
          "statusCode": 0,
          "detail": "Transaction Details",
          "data": {
            "TransactionType": "C2B",
            "TransID": "RKTQDM7W6S",
            "TransTime": "20191122063845",
            "TransAmount": "10000.00",
            "MerchantCode": "2*****0",
            "BillRefNumber": "2547********",
            "InvoiceNumber": "",
            "OrgAccountBalance": "49197.00",
            "CustomerMobile": "2547********",
            "FirstName": "John",
            "MiddleName": "",
            "LastName": "Doe"
          }
        }
    `
    return java
}